import React, { useEffect, useState } from 'react'
import styles from './AuthorAllCollections.module.css'
import CollectionsCard from '../CollectionsCard/CollectionsCard'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAuthorCollections } from '../../Slices/AuthorCollectionsSlice'

type Props = {
    page :any,
    setTotalPages:any,
    totalPages:any,
    authorId:any
}
const newCollections :any = []


const AuthorAllCollections = (props: Props) => {
    const {page, setTotalPages, totalPages, authorId} = props;
    const {pagination,  loading, collections } = useSelector((state:any)=> state.authorCollections);
    const {authorCollections } = useSelector((state:any)=> state.publicPageData);
    const {likedCollections, dislikedCollections} = useSelector((state:any)=> state.publicCollectionsData);
    
    const dispatch:any = useDispatch();

    // const authorId = 7;

    useEffect(()=>{
        dispatch(fetchAuthorCollections({page, authorId}))
    }, [])

    
    useEffect(()=>{
        // console.log(likedCollections, 'LIKED C')
        // console.log(dislikedCollections, 'DISLIKED C')

    }, [likedCollections, dislikedCollections])
    useEffect(()=>{
        if(page > 0 && (page === totalPages || page < totalPages )){
            dispatch(fetchAuthorCollections({page, authorId}))
        }
    }, [page])

   
    useEffect(() => {
        if (pagination?.total_pages !== undefined) {
            setTotalPages(pagination.total_pages);
        }
    }, [pagination, setTotalPages]);

    
  return (
    authorCollections?.map((e:any) => ( <CollectionsCard key={e?.id} id={e?.id} slug={e?.slug} creator={e?.author?.name} username={e?.author?.username} title={e?.title} loading={false} likes={e?.details?.likes}  dislikes={e?.details?.dislikes} uploadDate={e?.publish_date} votes={e?.votes} bookmarked={e?.bookmarked} liked={e?.liked} disliked={e?.disliked} url={e?.url} profilepic={e?.author?.pic} tags={e?.tags} description={e?.details?.description} />))
  )
}

export default AuthorAllCollections